import { formValidation } from './../MessageCreate/formValidation'
import moment from 'moment-timezone'

export function countFollowups(listData) {
  let count = 0
  if (Object.keys(listData).length > 0) {
    count = Object.keys(listData).length
  }
  return count
}

export function setDelay(blossomID) {
  let myDelay = true
  if (
    blossomID === 'fmocdc' ||
    blossomID === 'ceebackup' ||
    blossomID === 'c3alert' ||
    blossomID === 'c3aalert'
  ) {
    myDelay = false
  }
  return myDelay
}

// properlys set the title of the page based off of the blossom ID
export function setTitle(blossomID) {
  let myTitle = ''
  if (blossomID === 'bcp') {
    myTitle = myTitle + 'BCP Notification'
  } else if (blossomID === 'c3alert') {
    myTitle = myTitle + 'C3 Notification'
  } else if (blossomID === 'ceebackup') {
    myTitle = myTitle + 'CEE Backup Notification'
  } else if (blossomID === 'fmocdc') {
    myTitle = myTitle + 'FMOC DC Notification'
  } else if (blossomID === 'precall') {
    myTitle = myTitle + 'Product Recall Notification'
  } else if (blossomID === 'CI00598283') {
    myTitle = myTitle + 'HR Notification'
  } else if (blossomID === 'c3aalert') {
    myTitle = myTitle + 'C3A Notification'
  } else if (blossomID === 'developer') {
    myTitle = myTitle + 'Developer Notification'
  } else if (blossomID === 'shipt') {
    myTitle = myTitle + 'Shipt Notification'
  }
  return myTitle
}

function checkBlossomID(blossomID) {
  let blossomArr = ['precall', 'fmocdc', 'ceebackup']
  return blossomArr.includes(blossomID)
}

function setPhoneFlag(blossomID) {
  let blossomArr = [
    'precall',
    'fmocdc',
    'ceebackup',
    'c3alert',
    'bcp',
    'c3aalert',
    'developer',
    'shipt',
  ]
  return blossomArr.includes(blossomID)
}

export function checkifEmpty(callbackValue) {
  let isEmpty = true
  if (callbackValue !== null) {
    if (callbackValue.length > 0) {
      isEmpty = false
    }
  }
  return isEmpty
}

export function setValidMessage(activeStep) {
  let isValid = false
  if (activeStep > 0) {
    isValid = true
  }
  return isValid
}

export function initContactData(inputString, blossomID) {
  if (inputString) {
    // Expecting to be in 'pse' format
    let tempValue = []
    for (let i = 0; i <= 3; i++) {
      if (
        String(inputString).toLowerCase().charAt(i) === 'p' &&
        !setPhoneFlag(blossomID)
      ) {
        tempValue.push({
          id: i + 1,
          text: 'Phone',
          checked: true,
        })
      }
      if (String(inputString).toLowerCase().charAt(i) === 's') {
        tempValue.push({
          id: i + 1,
          text: 'SMS',
          checked: true,
        })
      }
      if (String(inputString).toLowerCase().charAt(i) === 'e') {
        tempValue.push({
          id: i + 1,
          text: 'Email',
          checked: true,
        })
      }
    }
    // Now check for missing fields to add them back in as false
    if (
      String(inputString).toLowerCase().indexOf('p') < 0 &&
      !setPhoneFlag(blossomID)
    ) {
      tempValue.push({
        id: tempValue.length + 1,
        text: 'Phone',
        checked: false,
      })
    }
    if (setPhoneFlag(blossomID)) {
      tempValue.push({
        id: tempValue.length + 1,
        text: 'Phone',
        checked: false,
      })
    }
    if (String(inputString).toLowerCase().indexOf('s') < 0) {
      tempValue.push({
        id: tempValue.length + 1,
        text: 'SMS',
        checked: false,
      })
    }
    if (String(inputString).toLowerCase().indexOf('e') < 0) {
      tempValue.push({
        id: tempValue.length + 1,
        text: 'Email',
        checked: false,
      })
    }
    return tempValue
  }
  if (setPhoneFlag(blossomID)) {
    return [
      {
        id: 1,
        text: 'Phone',
        checked: false,
      },
      {
        id: 2,
        text: 'SMS',
        checked: true,
      },
      { id: 3, text: 'Email', checked: true },
    ]
  } else {
    return [
      {
        id: 1,
        text: 'Phone',
        checked: true,
      },
      {
        id: 2,
        text: 'SMS',
        checked: true,
      },
      { id: 3, text: 'Email', checked: true },
    ]
  }
}

export function isWorkerListPopulated(obj) {
  // first check to see if the list is empty
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      // now that there's a value, check if there is a 'true' value
      if (obj[prop] === true) {
        return true
      }
    }
  }
  return false
}

export function getContactMethods(JSONcontactData, contactMethodSelected) {
  // Match item in map to provided contact Method
  var result = false
  JSONcontactData.filter((item) => item.text === contactMethodSelected).map(
    (item, i) => {
      result = item.checked
      return result
    },
  )
  return result
}

export function displayLanguage(displayLanguageData) {
  var displayLanguage = ''
  if (displayLanguageData) {
    displayLanguage = 'English Only Responses'
  } else {
    displayLanguage = 'Spanish and English Responses selected'
  }
  return displayLanguage
}

export function getTotalSMSCharacters(
  smsMessageData,
  notifyOnly,
  englishOnly,
  englishPositiveResponseData,
  englishNegativeResponseData,
  spanishPositiveResponseData,
  spanishNegativeResponseData,
) {
  let characterLength = 0
  if (smsMessageData != null) {
    characterLength += smsMessageData.length
  }
  if (notifyOnly === false) {
    // If Responses enabled, include length of 2 shorturls (23 each) + 6 newlines + 2 spaces + 'Msg & data rates may apply' (28) = 82
    characterLength += 82
    if (englishPositiveResponseData != null) {
      characterLength += englishPositiveResponseData.length
    }
    if (englishNegativeResponseData != null) {
      characterLength += englishNegativeResponseData.length
    }
    if (englishOnly === false) {
      // If Spanish responses also enabled, add length of 2 shorturls (23 each) + 4 newlines + 2 spaces = 52
      characterLength += 52
      if (spanishPositiveResponseData != null) {
        characterLength += spanishPositiveResponseData.length
      }

      if (spanishNegativeResponseData != null) {
        characterLength += spanishNegativeResponseData.length
      }
    }
  }
  return characterLength
}

// return true when only distro lists selected, otherwise return false if location
export function distroListOnlyValidation(input) {
  if (
    input !== null &&
    input !== '' &&
    (typeof input !== 'object' || Object.keys(input).length > 0)
  ) {
    for (var propt in input) {
      if (input[propt]) {
        if (!formValidation(propt, 'location', 'boolean')) {
          return false
        }
      }
    }
  }
  return true
}

export function isMessagePopulated(
  JSONcontactData,
  isTitleEmpty,
  isPhoneMessageEmpty,
  isSMSMessageEmpty,
  isEmailMessageEmpty,
  notifyFlag,
  languageFlag,
  isEngPosEmpty,
  isEngNegEmpty,
  isSpanPosEmpty,
  isSpanNegEmpty,
  totalSMSCharacters,
) {
  var enableNext = false
  if (!isTitleEmpty) {
    enableNext = true
  } else {
    return false
  }
  if (getContactMethods(JSONcontactData, 'Phone') === true) {
    if (getContactMethods(JSONcontactData, 'Phone') === !isPhoneMessageEmpty) {
      enableNext = true
    } else {
      return false
    }
  }
  if (getContactMethods(JSONcontactData, 'SMS') === true) {
    if (
      getContactMethods(JSONcontactData, 'SMS') === !isSMSMessageEmpty &&
      totalSMSCharacters <= 320
    ) {
      enableNext = true
    } else {
      return false
    }
  }
  if (getContactMethods(JSONcontactData, 'Email') === true) {
    if (getContactMethods(JSONcontactData, 'Email') === !isEmailMessageEmpty) {
      enableNext = true
    } else {
      return false
    }
  }
  if (!notifyFlag) {
    if (languageFlag) {
      if (!isEngPosEmpty && !isEngNegEmpty) {
        enableNext = true
      } else {
        return false
      }
    } else {
      if (
        !isEngPosEmpty &&
        !isEngNegEmpty &&
        !isSpanPosEmpty &&
        !isSpanNegEmpty
      ) {
        enableNext = true
      } else {
        return false
      }
    }
  }
  return enableNext
}

function proximityValidation(distanceFlag, distance) {
  if (!distanceFlag) return true
  return distance > 0
}

export function setHidePhoneFlag(ciData) {
  let hidePhoneFlag = false
  if (checkBlossomID(ciData)) {
    hidePhoneFlag = true
  }
  return hidePhoneFlag
}

export function itemsValidation(
  items,
  distanceFlag,
  distance,
  validProximityWorkerTypes,
) {
  // loop through the json list, and if any are true, return true, or else return false
  var returnVar = false
  items.map((item, i) => (returnVar = item.checked ? true : !!returnVar))

  return (
    returnVar &&
    proximityValidation(distanceFlag, distance) &&
    validProximityWorkerTypes
  )
}

export function displayContacts(contacts) {
  var tempString = ''
  var counter = 0

  for (var propt in contacts) {
    // count the number of items
    counter = contacts[propt] ? counter + 1 : counter
    // build the string
    tempString =
      tempString + (contacts[propt] ? modifyToTNumber(propt) + ', ' : '')
  }

  // chop off the last ', '
  if (counter > 0) {
    return tempString.slice(0, -2)
  } else {
    // if the string is empty, don't touch it to prevent it from blowing up
    return tempString
  }
}

// change number to standard Target store number
// input: 3
// Output: T0003
function modifyToTNumber(location) {
  if (location.length === 1) {
    return 'T000' + location
  } else if (location.length === 2) {
    return 'T00' + location
  } else if (location.length === 3) {
    return 'T0' + location
  } else if (location.length === 4) {
    return 'T' + location
  } else {
    return location
  }
}

export function displayContactMethod(JSONcontactData) {
  // take the contact method json list, and make it readable
  var tempString = ''
  JSONcontactData.map(
    (item, i) =>
      (tempString = tempString + (item.checked ? item.text + ', ' : '')),
  )
  // chop off the last ', '
  if (tempString.length > 0) {
    return tempString.slice(0, -2)
  } else {
    // if the string is empty, don't touch it to prevent it from blowing up
    return tempString
  }
}

export function displayDelay(displayData) {
  var displayDataMinutes = ''
  if (displayData) {
    displayDataMinutes = '15 Minutes'
  } else {
    displayDataMinutes = '2 Minutes'
  }
  return displayDataMinutes
}

export function displayNotify(displayData) {
  if (displayData) {
    return 'No Response Links'
  }
  return 'Include Response Links'
}

export function displayProximityWorkerTypes(displayProximityWorkerTypes) {
  let workerTypesString = ''
  // eslint-disable-next-line array-callback-return
  Object.entries(displayProximityWorkerTypes).map(([key, value]) => {
    if (value === true) {
      if (workerTypesString === '') {
        workerTypesString = key
      } else {
        workerTypesString = workerTypesString + ', ' + key
      }
    }
  })
  return workerTypesString.toUpperCase()
}

export function setDistance(number) {
  if (number) {
    return number
  }
  return 0
}

export function setWorkerType(workerTypesString) {
  return workerTypesString.split(', ')
}

export function setPrimaryJobCodes(ci) {
  let primaryJobCodes = null
  if (ci === 'precall') {
    primaryJobCodes = ['9102', '54541', '0620', '10307', '54601']
  }
  return primaryJobCodes
}

export function setFailoverJobCodes(ci) {
  let failoverJobCodes = null
  return failoverJobCodes
}

export function setNotifySupervisorJobCodesList(ci) {
  let notifySupervisorJobCodesList = null
  return notifySupervisorJobCodesList
}

export function finaltime(dateObject, timezone) {
  return (
    moment(dateObject).format('MM/DD/YYYY hh:mm A').toString() +
    ' ' +
    moment().tz(timezone).format('z')
  )
}

export function getSteps() {
  return [
    'Select Location(s)',
    'Contact Methods',
    'Choose Message Template (Optional)',
    'Create Message',
    'Schedule',
    'Summary',
  ]
}
